var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislikeDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.56733 9.7354C1.82733 10.1087 2.28733 10.3221 2.81399 10.3221H5.54733C5.72733 10.3221 5.894 10.3954 6.00733 10.5287C6.12733 10.6621 6.174 10.8487 6.14733 11.0421L5.80733 13.2287C5.66066 13.8821 6.09399 14.6154 6.74733 14.8354C7.35399 15.0621 8.06733 14.7554 8.35399 14.3221L11.1607 10.1421L11.2407 10.0087V4.1154L11.1407 4.0154L9.02733 2.38206C8.74733 2.10206 8.11399 1.94873 7.66733 1.94873H5.06733C4.17399 1.94873 3.27399 2.62206 3.07399 3.44206L1.43399 8.4354C1.26733 8.90873 1.31399 9.3754 1.56733 9.7354Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5236 12.1686H13.2103C14.2436 12.1686 14.6636 11.7686 14.6636 10.782V4.08198C14.6636 3.09531 14.2436 2.69531 13.2103 2.69531H12.5236C11.4903 2.69531 11.0703 3.09531 11.0703 4.08198V10.7886C11.0703 11.7686 11.4903 12.1686 12.5236 12.1686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeDark);
export default __webpack_public_path__ + "static/media/dislike_dark.eb8f23b9e7378db811df5562b421de13.svg";
export { ForwardRef as ReactComponent };